import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  toggle: false,
  apApprovers: [],
  approverList: [],
  selectedApInvoiceCharge: {},
  codingCompleteDate: '',
  apInvoiceID: 0,
  apInvoiceStatus: '',
  isPostedAlready: false,
  isReadyForApproval: false,
  isReadyForPost: false,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  pagination: {
    perPage: 10
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'approver',
      label: 'Approver',
      aria: 'Approver',
      width: '30%',
      sortable: true,
      searchable: true
    },
    {
      field: 'required',
      label: 'Required',
      aria: 'Required',
      width: '20%',
      sortable: true,
      searchable: true
    },
    {
      field: 'status',
      label: 'Status',
      aria: 'Status',
      width: '30%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      label: 'Created',
      date: true,
      width: '20%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    filterButton: {
      margin: '8px 0 22px'
    }
  }
})
